import * as React from 'react';
import IDirectoryHeader from './IDirectoryHeader';

import * as style from './DirectoryHeaderStyle.module.scss'

const DirectoryHeader: React.SFC<IDirectoryHeader> = (props) => {
  const { filterName } = props;

  return (
    <h1 className={style.title}>{filterName} Companies</h1>
  );
};

export default DirectoryHeader;

